module.exports = __webpack_public_path__ + "media/categories/1023-b1f8e709.svg";